import { FintechProductV2 } from "@b2bportal/core-fintech-ui";
import type { DisruptionFintechProductProps } from "@tenant/disruption";
import styles from "./DisruptionFintechProduct.module.scss";
import { DisruptionFintechProductSelection } from "./DisruptionFintechProductSelection";

export const DisruptionFintechProduct = (
  props: DisruptionFintechProductProps
) => {
  return (
    <div className={styles.DisruptionFintechProduct}>
      <FintechProductV2
        {...props}
        infoLinks={{
          howItWorksDialog: props.howItWorksDialog,
          ui: props.infoLinksUI,
          viewTermsLink: props.viewTermsLink,
        }}
        selectionOffers={{
          options: props.selectionOffers,
          Component: (offerProps) => {
            return (
              <DisruptionFintechProductSelection
                {...offerProps}
                continueClicked={props.continueClicked}
              />
            );
          },
        }}
      />
    </div>
  );
};
